import * as ng from 'angular';

ng.module('e360').component('mockSelect', {
   templateUrl: require('./mock-select.component.html'),
   bindings: {
      placeholderText: '@'
   }
});